import {
  FeriadoService
} from "../../services/FeriadoService";
import PerfilService from "../../services/PerfilService";
import {
  tipoPerfil
} from "../../constants";

export default {
  name: "Navigation",
  menu_admin:false,
  props: {
    drawerClicked: {
      required: true,
      type: Boolean,
    },
  },

  watch: {
    drawerClicked() {
      this.drawer = !this.drawer;
    },
  },
  async beforeMount() {
    this.menu_admin = false;
    this.user_tmp = localStorage.user_id;
    await this.pegarPerfilUsuario();
    this.verificarFeriados();
    this.verificarCivil();

  },


  methods: {
    verificarCivil() {
      if (this.$store.state.user.Civil) {
        if (this.$route.path === "/" ) {
          this.$router.push("/calendario-civis");
        }
        this.menu = []; 
        this.menu_default  = [];
        this.menu_default.push(this.calendarioCivis[0]);
        if (this.$store.state.user.Perfis.indexOf(tipoPerfil['GERENCIA']) != -1) {
          this.menu_default.push(this.pesquisarCivil[0]);
          this.menu_default.push(this.configuracaoCivil[0]);

        }
      }
    },

    async montar_menu() {



      let arrayPerfil = [];
      this.$store.state.user.Perfis.map((element) => {
        arrayPerfil.push(element.id);
      })



      this.$store.state.user.Perfis = arrayPerfil;
      //this.hir = this.$store.state.perfil_hir;

      if (localStorage.perfil_hir) {
        this.hir = localStorage.perfil_hir;
        this.$store.state.perfil_hir = localStorage.perfil_hir;
        // = localStorage.perfil_hir;
      }
      //alert(this.$store.state.perfil_hir);
      if(!this.$store.state.user.Civil){

      await PerfilService.getMenu(localStorage.perfil_id).then((res) => {
        this.menu = res.content;
      

        //verifica a menor e se esta em branco no localstorage e set
        if (localStorage.perfil_id) {

          //console.log(localStorage.perfil_id)
        }
      


        // let ary;
        //for (ary in this.$store.state.user.Perfis) {
        //  console.log(ary)
        //}

        this.$store.commit("setListaMenu", this.menu);
      })

      if(localStorage.perfil_label != 'Solicitante') {
        //this.menu_default.push(this.calendarioCivis[0]);
      }
      if (this.$store.state.user.Perfis.indexOf(tipoPerfil['GERENCIA']) != -1) {
        this.menu_default.push(this.pesquisarCivil[0]);
      }
    }
    this.verificarCivil();
      if(localStorage.perfil_label_admin == 'admin') {
        this.menu_admin = true;
      }
    },
    async verificarFeriados() {
      const response = await FeriadoService.getFeriados();
      if (response.length === 0) {
        this.items.shift()
        // if (this.$route.path === "/" && this.$store.state.user.Perfis.indexOf(tipoPerfil['GERENCIA']) !== -1) {
        //   window.location.href = "/configuracoes/atribuir-feriados"
        // }
      }

    },
    async pegarPerfilUsuario() {
      this.user_tmp = localStorage.user_id;
      this.user_tmp_label = localStorage.user_id;

      this.montar_menu();



      // if (arrayPerfil.indexOf(tipoPerfil['GERENCIA']) !== -1) {
      //   this.disabled.configuracao = false;

      // }
      // if (arrayPerfil.indexOf(tipoPerfil['SOLICITANTE']) !== -1 && arrayPerfil.length === 1) {
      //   this.disabled.items = true;

      // }

      // if (arrayPerfil.indexOf(tipoPerfil['CHEFE_SEPLAN']) !== -1 || arrayPerfil.indexOf(tipoPerfil['COMANDANTE']) !== -1) {
      //   this.disabled.feriasEscolares = false

      // }

    }
  },

  data: () => ({
    drawer: false,
    calendario: [{
      title: "Calendário de Férias",
      icon: "mdi-calendar",
      path: "/",
    }, ],
    calendarioCivis: [{
        id: 'calendar-1',
        funcionalidade_nome: "Calendário de Férias",
        icone: "mdi-calendar",
        hierarquia: 1,
        rota: "/calendario-civis",
      },

    ],

    pesquisarCivil: [{
      id: 'pesquisa-0',
      funcionalidade_nome: "Pesquisar Civil",
      icone: "mdi-magnify",
      hierarquia: 0,
      rota: "/pesquisar-civis",
    }, ],

    configuracaoCivil: [{
      funcionalidade_nome: "Configurações Civil",
      hierarquia: 2,
      icone: "mdi-cog",
      id: 37,
      rota: "/#",
      sub: [
      {
        funcionalidade_nome: "Atribuir Feriado",
        hierarquia: 2,
        icone: "mdi-menu",
        id: 10,
        parent_id: 37,
        rota: "/ferias-civis/configuracoes/atribuir-feriados",
      }]
    }],
    menu: [],
    user_tmp: 0,
    user_tmp_label:false,
    menu_force: [

    ],
    menu_default: [
      {
        id: 'calendar-0',
        funcionalidade_nome: "Calendário de Férias",
        icone: "mdi-calendar",
        hierarquia: 0,
        rota: "/",
      }
    ],
    items: [{
        title: "Comparativo",
        icon: "mdi-account",
        path: "/configuracoes/comparativo",
      },
      {
        title: "Gerenciar Usuários",
        icon: "mdi-account",
        path: "/gerenciar-usuarios",
      },
      {
        title: "Mapeamento Férias",
        icon: "mdi-earth",
        path: "/mapeamento-ferias",
      },
    ],

    FeriasEscolares: [{
        title: "Calendário de Férias Escolares",
        path: "/ferias-escolares/calendario-ferias-escolares",
      },
      {
        title: "Discentes de Férias",
        path: "/ferias-escolares/discente-ferias",
      },
    ],

    disabled: {
      configuracao: true,
      feriasEscolares: true,
      items: false
    },
    hir: null,
    configuracoes: [{
        title: "Parametrizar Calendário",
        path: "/configuracoes/parametrizar-calendario",
      },
      {
        title: "Atribuir Feriados",
        path: "/configuracoes/atribuir-feriados",
      },
    ],
    tmp_hr: 0,
    right: null,
  }),
};